import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import './assets/main.css'

const app = createApp(App)

app.use(createPinia())

console.log('🚀 Iniciando CallBlasterAI...')
app.mount('#app')
console.log('✅ CallBlasterAI montado correctamente')
